import React from 'react'
import Modal from 'react-bootstrap/Modal'
import styled from 'styled-components'
import PointsComponent from '../../../influencerComponents/PointsComponent'
import purchase from 'assets/images/dashboard/purchase.png'
import invitation from 'assets/images/dashboard/invite.png'
import promo from 'assets/images/dashboard/promo.png'
import mission from 'assets/images/dashboard/mission.png'

const ModalContainer = styled(Modal)`
  //.border-radius-2 div {
  //  border-radius: 0.5em !important;
  //}
`
const ModalHeader = styled(Modal.Header)`
  background: linear-gradient(270deg, #90dc6c 0%, #17bfce 100%);
`
const ModalTitle = styled(Modal.Title)`
  color: #ffffff;
  font-size: 1.25em;
  font-weight: bold;
  line-height: 1.5em;
  text-align: center;
  margin-left: 23.5%;
`

export default function PointsModal(props) {
  return (
    <ModalContainer {...props} dialogClassName="border-radius-2" centered>
      <ModalHeader closeButton>
        <ModalTitle>How can I get more points</ModalTitle>
      </ModalHeader>
      <Modal.Body>
        <PointsComponent
          imageSrc={`${purchase}`}
          title="Purchase"
          description="Purchase tickets and get more points, when you invite friends and they purchase, you get more points"
        />
        <PointsComponent
          imageSrc={`${invitation}`}
          title="Invite Friends"
          description="Invite your friends and get more points with each registration done through your link"
        />
        <PointsComponent
          imageSrc={`${promo}`}
          title="Promo Code"
          description="Share your promo code with your friends and win big prizes when they use your code while purchasing through our system"
        />
        <PointsComponent
          imageSrc={`${mission}`}
          title="Missions"
          description="Complete missions and challenges to earn huge prizes and discounts, get started and share on social media"
        />
      </Modal.Body>
    </ModalContainer>
  )
}
